import React, { ReactElement } from "react";
import { Chapter } from "../../components/Chapter";
import Heading from "../../components/Heading";
import { Timeline } from "../../components/Timeline";
import { PageBreak } from "../../components/PageBreak";
import { BelangrijkeFinancieleGebeurtenissenHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import { mapGebeurtenisToIcon } from "./gebeurtenis-icon-mapper";
  
  const BelangijkFinancieleGebeurtenissenChapter = ({
    gebeurtenissen,
    titel
  }: Partial<BelangrijkeFinancieleGebeurtenissenHoofdstuk>): ReactElement => {
    
    const timelineEvents = (gebeurtenissen || []).map((gebeurtenis, index) => ({
      id: `${gebeurtenis.jaar}-${gebeurtenis.maand}-${index}`,
      year: gebeurtenis.jaar,
      month: new Date(0, gebeurtenis.maand - 1).toLocaleString('nl-NL', { month: 'short' }).toUpperCase(),
      title: gebeurtenis.omschrijving || '',
      icon: mapGebeurtenisToIcon(gebeurtenis.omschrijving || ''),
      details: [
        ...(gebeurtenis.leeftijdAanvrager ? [{ value: gebeurtenis.leeftijdAanvrager }] : []),
        ...(gebeurtenis.leeftijdPartner ? [{ value: gebeurtenis.leeftijdPartner }] : [])
      ],
      side: (index % 2 === 0 ? 'left' : 'right') as 'left' | 'right'
    }));
    
    // Get unique years for all events
    const years = Array.from(new Set(timelineEvents.map(event => event.year))).sort((a, b) => a - b);
    
    return (
      <Chapter>
        <Heading text={titel!} level={3} />
        <Timeline events={timelineEvents} years={years} />
        <PageBreak />
      </Chapter>
    );
  };
  
  export default BelangijkFinancieleGebeurtenissenChapter;